import { supabase } from '../../../lib/supabase';
import { assertWhatsAppFileSize } from '../hooks/whatsappMediaLimits';

/** Sobe o arquivo da conversa para o R2 e devolve a URL pública. */
export async function uploadChatFileToR2(file: File): Promise<string> {
  assertWhatsAppFileSize(file);

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    throw new Error('Usuário não autenticado. Faça login novamente.');
  }

  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${supabaseUrl}/functions/v1/upload-media`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      apikey: supabaseKey,
    },
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Falha no upload da mídia para R2');
  }

  const data = await response.json();
  if (!data?.url || typeof data.url !== 'string') {
    throw new Error('URL não retornada pelo upload');
  }
  return data.url;
}
